import React, { useEffect, useState, useRef } from "react";
import Flatpickr from "react-flatpickr";
import Tippy from '@tippyjs/react';
import { TextInput } from "@opendate-app/setlist";
import FanFilterSelect from "./FanFilterSelect";

import { formInputContainerStyle, formInputStyle } from "./FanFilterGroupForm";

const dateTimePicker = (value, onClose) => {
  return <Flatpickr
    options={{
      enableTime: true,
      dateFormat: "M j, Y \\a\\t h:i K",
    }}
    placeholder={"Select a date"}
    value={value}
    onClose={onClose}
    style={{
      border: "none",
      width: "100%",
    }}
  />;
};

const filterTypeOptions = [
  "Fan Attribute",
];

const datePickerContainerStyle = {
  marginRight: 8,
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  backgroundColor: "var(--sl-bg-primary, white)",
  width: 250,
  height: 40,
  borderRadius: 8,
  padding: "0 10px",
  border: "1px solid var(--sl-border-primary, #ccc)",
};

const calendarIconStyle = {
  fontSize: "14px",
  color: "var(--sl-text-brand, #1982C4)"
};

const UserDataForm = (props) => {
  const {
    fanFilter,
    updateFanFilter,
  } = props;

  const mountedRef = useRef(false);
  const pendingValueSaveRef = useRef(null);

  const [valueInputType, setValueInputType] = useState("none");

  const supportedAttributes = fanFilter.filter_param_options.fan_attribute || [];
  const supportedConditions = fanFilter.filter_param_options.condition || [];

  const userDataType = fanFilter.filter_params.user_data_type || "";
  const fanAttribute = fanFilter.filter_params.fan_attribute || "";
  const condition = fanFilter.filter_params.condition || "";
  const values = fanFilter.filter_params.values || [""];

  const [valueOne, setValueOne] = useState(values[0]);

  useEffect(() => {
    if (!fanFilter.filter_params.condition) {
      setValueInputType("none");
    } else if (fanFilter.filter_params.condition === "is before" || fanFilter.filter_params.condition === "is after") {
      setValueInputType("singledate");
    } else if (fanFilter.filter_params.condition === "is between") {
      setValueInputType("multidate");
    } else {
      setValueInputType("text");
    }
  }, [fanFilter.filter_params.condition]);

  useEffect(() => {
    if (valueOne === undefined) return;

    if (!mountedRef.current) {
      mountedRef.current = true;
      return;
    }

    const debounceUpdateValueOne = _.debounce(() => {
      updateFanFilterValueOne(valueOne);
    }, 500);

    debounceUpdateValueOne();
    pendingValueSaveRef.current = debounceUpdateValueOne;

    return () => {
      debounceUpdateValueOne.cancel();
    };
  }, [valueOne]);

  const updateFanFilterValueOne = (value) => {
    let newValues = fanFilter.filter_params.values || [];
    newValues[0] = value;

    updateFanFilter({
      filter_params: {
        ...fanFilter.filter_params,
        values: newValues
      }
    });
  };

  const updateFanFilterValueTwo = (value) => {
    let newValues = fanFilter.filter_params.values;
    newValues[1] = value;

    updateFanFilter({
      filter_params: {
        ...fanFilter.filter_params,
        values: newValues
      }
    });
  };

  return (
    <>
      <div style={formInputContainerStyle}>
        <FanFilterSelect
          aria-label="Filter type"
          options={filterTypeOptions.map((filterType) => ({ value: filterType, label: filterType }))}
          value={userDataType || null}
          onChange={(value) => updateFanFilter({
            filter_params: {
              user_data_type: value,
            },
          })}
        />
      </div>
      <div style={formInputContainerStyle}>
        <FanFilterSelect
          aria-label="Fan attribute"
          placeholder={userDataType === "Fan Attribute" ? "fan attribute" : "event attribute"}
          options={supportedAttributes.map((attribute) => ({ value: attribute, label: attribute }))}
          value={fanAttribute || null}
          onChange={(value) => updateFanFilter({
            filter_params: {
              ...fanFilter.filter_params,
              fan_attribute: value,
              condition: "",
              values: [""],
            },
          })}
        />
      </div>
      <div style={formInputContainerStyle}>
        <FanFilterSelect
          aria-label="Select a condition"
          placeholder="Select a condition"
          disabled={!fanAttribute}
          options={supportedConditions.map((supportedCondition) => ({ value: supportedCondition, label: supportedCondition }))}
          value={condition || null}
          onChange={(value) => {
            updateFanFilter({
              filter_params: {
                ...fanFilter.filter_params,
                condition: value,
                values: [""],
              },
            });
            setValueOne(undefined);
          }}
        />
      </div>
      {valueInputType === "none" ? null : valueInputType === "multidate" ? (
        <>
          <div style={{
            ...datePickerContainerStyle,
            border: values[0] ? "1px solid var(--sl-border-primary, #ccc)" : "1px solid var(--sl-border-error, #FF595E)",
          }}>
            <div className="pr-2" style={calendarIconStyle}>
              <i className="far fa-calendar"></i>
            </div>
            {dateTimePicker(values[0], (dates) => updateFanFilterValueOne(dates[0]))}
          </div>
          <div style={formInputContainerStyle}>and</div>
          <div style={{
            ...datePickerContainerStyle,
            border: values[1] ? "1px solid var(--sl-border-primary, #ccc)" : "1px solid var(--sl-border-error, #FF595E)",
          }}>
            <div className="pr-2" style={calendarIconStyle}>
              <i className="far fa-calendar"></i>
            </div>
            {dateTimePicker(values[1], (dates) => updateFanFilterValueTwo(dates[0]))}
          </div>
        </>
      ) : valueInputType === "singledate" ? (
        <div style={{
          ...datePickerContainerStyle,
          border: values[0] ? "1px solid var(--sl-border-primary, #ccc)" : "1px solid var(--sl-border-error, #FF595E)",
        }}>
          <div className="pr-2" style={calendarIconStyle}>
            <i className="far fa-calendar"></i>
          </div>
          {dateTimePicker(values[0], (dates) => updateFanFilterValueOne(dates[0]))}
        </div>
      ) : (
        <div style={{ ...formInputContainerStyle, width: 200 }}>
          <TextInput
            aria-label="value"
            disabled={!condition}
            type="text"
            value={valueOne || ""}
            onChange={(e) => setValueOne(e.target.value)}
            onBlur={() => {
              pendingValueSaveRef.current?.cancel();
              if ((valueOne ?? "") !== (values[0] ?? "")) updateFanFilterValueOne(valueOne);
            }}
            placeholder="value"
          />
        </div>
      )}
      {fanFilter.filter_validation_errors.length ? (
        <Tippy content={fanFilter.filter_validation_errors.join(" ")}>
          <i className="far fa-circle-exclamation" style={{color: "var(--sl-text-error, #FF595E)" }}/>
        </Tippy>
      ) : null}
    </>
  );
};

export default UserDataForm;
